module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "textSection"
  }, [_c('div', [_c('h1', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.valid) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "150px"
    }
  }, [_vm._v("Votre inscription a bien été validée,\n                vous pouvez désormais vous connecter sur le site de Savoir Être Aidant")])]) : _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "150px"
    }
  }, [_vm._v("Ce lien est invalide ou a expiré.")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3febb350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterConfirmation.vue
// module id = 444
// module chunks = 1